import QuestionItemPoolBody from "pages/ManagementPage/questionSection/questionItemCard/QuestionItemPoolBody/QuestionItemPoolBody";

export default QuestionItemPoolBody;
